import Showdown from 'showdown';
import ScIconNavBar from '@garmin/support-components/src/components/ScIconNavBar/index.vue';
import ScIconNavBarItem from '@garmin/support-components/src/components/ScIconNavBar/ScIconNavBarItem.vue';
import ScFriendlyHero from '@garmin/support-components/src/components/ScFriendlyHero/index.vue';
import { mapGetters } from 'vuex';
import { Analytics } from '@garmin/support-analytics';
import ProductSearch from '../product-search/product-search.vue';
import HeroBanner from '../hero-banner/hero-banner.vue';
import { enabledEnhancedContactLocales } from './config';
import './transition.scss';

const converter = new Showdown.Converter();

export default {
  name: 'Transition',
  components: {
    HeroBanner,
    ProductSearch,
    ScIconNavBar,
    ScIconNavBarItem,
    ScFriendlyHero,
  },
  props: {
    children: {
      default() {
        return [];
      },
      type: Array,
    },
    customProps: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  data() {
    return {
      showHelpLinkDetails: false,
      redirectBaseUrl: false,
      focus: false,
      translations: {
        contactSupportHeading: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactSupportHeading',
          '',
        ),
        videosHeading: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.videosHeading',
          '',
        ),
        manualsHeading: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.manualsHeading',
          '',
        ),
        softwareHeading: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.softwareHeading',
          '',
        ),
        contactSupportIntroText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactSupportIntroductionText',
          '',
        ),
        videosIntroText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.videosIntroductionText',
          '',
        ),
        manualsIntroText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.manualsIntroductionText',
          '',
        ),
        softwareIntroText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.softwareIntroductionText',
          '',
        ),
        manualsAlternateFlowText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.manualsAlternateFlowText',
          '',
        ),
        manualsAlternateFlowLink: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.manualsAlternateFlowLink',
          '',
        ),
        manualsAlternateFlowLinkText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.manualsAlternateFlowLinkText',
          '',
        ),
        manualsSystemsAviation: converter.makeHtml(
          this.$safeGet(
            this.$store.getters.translations,
            'transitionPages.scTransitionPages.manualsSystemsFlow',
            '',
          ),
        ),
        manualsSystemsMarine: converter.makeHtml(
          this.$safeGet(
            this.$store.getters.translations,
            'transitionPages.scTransitionPages.marineManualsFlow',
            '',
          ),
        ),
        contactMethods: converter.makeHtml(
          this.$safeGet(
            this.$store.getters.translations,
            'transitionPages.scTransitionPages.additionalContactMethods',
            '',
          ),
        ),
        submitFeedback: converter.makeHtml(
          this.$safeGet(
            this.$store.getters.translations,
            'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.submitFeedbackOptions',
            '',
          ),
        ),
        supportCenterCta: converter.makeHtml(
          this.$safeGet(
            this.$store.getters.translations,
            'transitionPages.scTransitionPages.supportCenterHomeCta',
            '',
          ),
        ),
        displayAdditionalInfo: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.displayAdditionalInfo',
          '',
        ),
        contactSupportProductSearchMessageLabel: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportProductSearchMessageLabel',
          '',
        ),
        contactSupportProductSearchMessageText: converter.makeHtml(
          this.$safeGet(
            this.$store.getters.translations,
            'transitionPages.scTransitionPages.contactSupportProductSearchMessageText',
            '',
          ),
        ),
        contactSupportFaqLinkText: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportProductSearchMessageUrl.urlContactSupportTransitionMessageLink.text',
          '',
        ),
        contactSupportFaqLink: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportProductSearchMessageUrl.urlContactSupportTransitionMessageLink.link',
          '',
        ),
        noProductFlowPrompt: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.noProductFlowPrompt',
          '',
        ),
        checkOrderText: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlOrderOrReturnStatus.text',
          '',
        ),
        checkOrderTextUrl: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlOrderOrReturnStatus.link',
          '',
        ),
        checkOrderTextInternal: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlOrderOrReturnStatus.internal',
          '',
        ),
        reportMapErrorText: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlMapUpdate.text',
          '',
        ),
        reportMapErrorTextUrl: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlMapUpdate.link',
          '',
        ),
        reportMapErrorTextInternal: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlMapUpdate.internal',
          '',
        ),
        reportMarineMapErrorText: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlMapErrorMarine.text',
          '',
        ),
        reportMarineMapErrorTextUrl: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlMapErrorMarine.link',
          '',
        ),
        reportMarineMapErrorTextInternal: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlMapErrorMarine.internal',
          '',
        ),
        requestRefundText: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlReturnForRefundRequest.text',
          '',
        ),
        requestRefundTextUrl: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlReturnForRefundRequest.link',
          '',
        ),
        requestRefundTextInternal: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlReturnForRefundRequest.internal',
          '',
        ),
        otherHelpTopicsText: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlNoProductFlow.text',
          '',
        ),
        otherHelpTopicsTextUrl: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlNoProductFlow.link',
          '',
        ),
        otherHelpTopicsTextInternal: this.$safeGet(
          this.$store.getters.translations,
          // eslint-disable-next-line max-len
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.links.urlNoProductFlow.internal',
          '',
        ),
        additionalContactHeading: this.$safeGet(
          this.$store.getters.translations,
          'transitionPages.scTransitionPages.contactSupportTransitionPage.contactSupportTransitionPage.contactLinkGroup.contactLinks.groupTitle',
          '',
        ),
      },
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('focus')) {
      const focus = params.get('focus');

      switch (focus) {
        case 'manuals':
          this.focus = 'manuals';
          break;
        case 'videos':
          this.focus = 'videos';
          break;
        case 'software':
          this.focus = 'software';
          break;
        case 'topics':
          this.focus = 'topics';
          break;
        default:
          this.focus = 'manuals';
          break;
      }
    } else {
      this.focus = 'manuals';
    }

    if (!this.customProps.redirectBaseUrl) {
      this.redirectBaseUrl = 'https://support.garmin.com/';
    } else {
      this.redirectBaseUrl = this.customProps.redirectBaseUrl;
    }
  },
  computed: {
    ...mapGetters([
      'locale',
      'product',
      'productFilteredList',
      'marineEnabled',
      'aviationEnabled',
    ]),

    displayEnhancedContactExperience() {
      return (
        this.displayAdditionalContactInfo
        && enabledEnhancedContactLocales.includes(this.locale)
        && this.translations.additionalContactHeading
      );
    },
    displayAdditionalContactInfo() {
      return (
        this.focus === 'topics'
        && this.translations.displayAdditionalInfo
      );
    },

    displayFeedbackOptions() {
      return (
        this.displayAdditionalContactInfo
        || this.displayEnhancedContactExperience
      );
    },

    getIconNavBarItems() {
      return [
        {
          ctaText: this.translations.checkOrderText,
          ctaUrl: this.translations.checkOrderTextUrl,
          gaEventString: `Support Transition,CTA Icon Link,${this.translations.checkOrderTextInternal}`,
          icon: 'order',
        },
        {
          ctaText: this.translations.requestRefundText,
          ctaUrl: this.translations.requestRefundTextUrl,
          gaEventString: `Support Transition,CTA Icon Link,${this.translations.requestRefundTextInternal}`,
          icon: 'return',
        },
        {
          ctaText: this.translations.reportMapErrorText,
          ctaUrl: this.translations.reportMapErrorTextUrl,
          gaEventString: `Support Transition,CTA Icon Link,${this.translations.reportMapErrorTextInternal}`,
          icon: 'mapError',
        },
        {
          ctaText: this.translations.reportMarineMapErrorText,
          ctaUrl: this.translations.reportMarineMapErrorTextUrl,
          gaEventString: `Support Transition,CTA Icon Link,${this.translations.reportMarineMapErrorTextInternal}`,
          icon: 'marineMapError',
        },
        {
          ctaText: this.translations.otherHelpTopicsText,
          ctaUrl: this.translations.otherHelpTopicsTextUrl,
          gaEventString: `Support Transition,CTA Icon Link,${this.translations.otherHelpTopicsTextInternal}`,
          icon: 'help',
        },
      ].filter((i) => i.ctaText && i.ctaUrl);
    },
  },
  methods: {
    onAdditionalInfoLinkClick(e) {
      if (e.target.tagName.toLowerCase() === 'a') {
        e.preventDefault();

        Analytics.trackAnalyticsEvent({
          link_type: 'Internal Link',
          page_type: 'Support Transition',
          event_category: 'Support Transition',
          event_action: 'Internal Link',
          event_label: e.target.innerText,
        });

        if (e.target.href.length > 0) {
          if (e.target.target.toLowerCase() === '_blank') {
            window.open(e.target.href);
          } else {
            window.location = e.target.href;
          }
        }
      }
    },
    onHelpLinkClick(payload) {
      const {
        // eslint-disable-next-line camelcase
        event_category, event_action, event_label, link,
      } = payload;
      // eslint-disable-next-line camelcase
      Analytics.trackAnalyticsEvent({ event_category, event_action, event_label });
      if (link) window.open(link, '_self');
    },
    onNoProductFlowClick() {
      this.$store.dispatch('noProductFlowEnable');
    },
  },
};
